import { deeplinkNavigation } from './DeeplinkNavigationParams'

export const navigateMoneyManagement = () => {
  deeplinkNavigation({
    name: 'MediaWebView',
    title: '家族のお金メディア👨‍🎓',
    uri: 'https://www.osidori.co/app/cate.php',
  })
}
